








































import Vue from 'vue';
import { Message } from 'mycorems-app-shared';
import { BounceRecipient } from '@/types';
import extract, { getCustomFieldValue } from './customField';

export default Vue.extend({
  props: {
    bounces: {
      type: Array as () => BounceRecipient[],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      headings: ['Email', 'Name', 'Reason'],
    };
  },
  computed: {
    customFields(): string[] {
      return extract(this.bounces);
    },
  },
  methods: {
    getCustomFieldValue,
  },
  components: {
    message: Message,
  },
});
